import { AlertTriangle } from 'lucide-react';
import Modal from './Modal';

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = 'Konfirmo',
  cancelText = 'Anulo',
  variant = 'danger',
  isLoading = false,
}: ConfirmDialogProps) {
  const confirmButtonClass = {
    danger: 'btn-danger',
    warning: 'bg-amber-500 text-white px-4 py-2 rounded-lg font-medium hover:bg-amber-600 transition-colors disabled:opacity-50',
    info: 'btn-primary',
  };

  const iconColor = {
    danger: 'text-red-500',
    warning: 'text-amber-500',
    info: 'text-barrikadave-500',
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="flex flex-col items-center text-center">
        <div className="mb-4">
          <AlertTriangle className={`h-12 w-12 ${iconColor[variant]}`} />
        </div>
        <p className="text-gray-600 mb-6">{message}</p>
        <div className="flex gap-3 w-full">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="btn-ghost flex-1"
          >
            {cancelText}
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className={`flex-1 ${confirmButtonClass[variant]}`}
          >
            {isLoading ? 'Duke procesuar...' : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
